package pl.mothdigital.neuronowi.components.error

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.forms.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import kotlinx.browser.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

@Composable
fun NotFoundPage() {
    val ctx = rememberPageContext()

    LaunchedEffect(Unit) {
        document.title = "${StringResources.APP_NAME} - ${StringResources.NOT_FOUND}"
    }

    Column(
        modifier = Modifier.fillMaxSize().minHeight(100.percent),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Image(
            src = ImageResources.navHeaderLogo.src,
            description = ImageResources.navHeaderLogo.description,
            modifier = Modifier
                .display(DisplayStyle.Block)
                .height(16.cssRem),
        )
        VerticalSpacer((1.2).cssRem)
        SpanText(
            text = StringResources.NOT_FOUND,
            modifier = TextBaseStyle.toModifier()
                .fontSize((1.5).cssRem)
                .margin(topBottom = 1.cssRem)
                .padding(0.px)
                .textAlign(TextAlign.Center)
                .fontWeight(FontWeight.Normal),
        )
        VerticalSpacer((0.5).cssRem)
        Button(
            onClick = { ctx.router.navigateTo(Screen.Home.route) },
            modifier = Modifier.padding(8.px),
            colorPalette = SiteTheme.green,
            type = ButtonType.Button,
        ) {
            SpanText(
                text = StringResources.HOME_PAGE_TITLE,
                modifier = TextBaseStyle.toModifier()
                    .fontSize(0.8.cssRem)
                    .fontWeight(FontWeight.Normal)
                    .color(SiteTheme.white._900),
            )
        }
    }
}
